import React, { FunctionComponent } from 'react'
import classnames from 'classnames'
import { Icon, IconType } from '../Icon'
import { Tooltip as ReactTooltip } from 'react-tooltip'

interface IDefaultProps {
  className: string
  enforceMaxWidth?: boolean
  iconColor: string
}

interface IProps extends Partial<IDefaultProps> {
  valueKey: string
  content?: any
  tooltipText: string
  tooltipHtml?: string
  showIcon?: boolean
}

const defaultProps: IDefaultProps & { showIcon: boolean } = {
  className: null,
  enforceMaxWidth: true,
  iconColor: 'text-primary',
  showIcon: true,
}

const TooltipInfo: FunctionComponent<IProps> = ({
  valueKey,
  content,
  tooltipText,
  tooltipHtml,
  className,
  enforceMaxWidth,
  iconColor,
  showIcon,
}) => {
  const tooltipProps = tooltipHtml
    ? { 'data-tooltip-html': tooltipHtml }
    : { 'data-tooltip-content': tooltipText }

  return (
    <span className={classnames('flex items-center normal-case', className)}>
      {showIcon ? (
        <>
          <span>{content}</span>
          <span data-tooltip-id={`tooltip-${valueKey}`} {...tooltipProps}>
            <Icon type={IconType.info} className={iconColor + ' ml-1'} />
          </span>
        </>
      ) : (
        <span data-tooltip-id={`tooltip-${valueKey}`} {...tooltipProps}>
          {content}
        </span>
      )}
      <ReactTooltip
        id={`tooltip-${valueKey}`}
        className={classnames(
          '!bg-primary !text-xs whitespace-normal',
          enforceMaxWidth && '!w-64 ',
        )}
      />
    </span>
  )
}

TooltipInfo.defaultProps = defaultProps

export { TooltipInfo }
